"use client"

import { useContext, useState } from "react"
import { DataContext } from "../Context/DataContext"
import { useNavigate } from "react-router-dom"
import { FaGasPump, FaUserFriends, FaTachometerAlt } from "react-icons/fa"
import { BsFillGearFill } from "react-icons/bs"
import { FiZap } from 'react-icons/fi'
import { FaCar, FaStar } from 'react-icons/fa';
import { GiSteeringWheel } from 'react-icons/gi';
import { BounceLoader } from 'react-spinners';
import styles  from '../Homepage/Homepage.module.css';
import carImage from '../Homepage/35.jpg';

const testimonialsData = [
  {
    id: 1,
    text: "The BMW 5 Series was impeccable! Smooth ride and excellent service with ample space. Will definitely rent again.",
    carModel: "BMW 5 Series",
    customerName: "Sarah Johnson",
    customerRole: "Business Traveler",
    avatar: "S",
    rating: 5
  },
  {
    id: 2,
    text: "Perfect family Toyota Highlander with ample space. Clean, well-maintained, and great value for money.",
    carModel: "Toyota Highlander",
    customerName: "Michael Chen",
    customerRole: "Family Vacation",
    avatar: "M",
    rating: 5
  },
  {
    id: 3,
    text: "Convertible Ford Mustang made our coastal drive unforgettable! 24/7 support was a lifesaver and value for money.",
    carModel: "Ford Mustang",
    customerName: "Emma Rodriguez",
    customerRole: "Road Trip Enthusiast",
    avatar: "E",
    rating: 5
  }
];

export default function Homepage() {
  const { cars, loading, setSelectedCar } = useContext(DataContext)
  const navigate = useNavigate() // hook للتنقل بين الصفحات
  const [isLoading, setIsLoading] = useState(false) // state لللودر

  if (loading) {
    return <div className={styles.loading}>Loading cars...</div>
  }

  const handleCarSelect = (car) => {
    setIsLoading(true); // اظهار اللودر
    setSelectedCar(car)
    setTimeout(() => {
      setIsLoading(false); // اخفاء اللودر
      navigate(`/CarDetails/${car.id}`)
    }, 3000) // محاكاة التحميل
  }

  // دالة للتنقل لصفحة Cars عند الضغط على See fleet
  const goToCarsPage = () => {
    navigate("/cars");
  }

  return (
    <>
      {isLoading && (
        <div className={styles.loaderOverlay}>
          <BounceLoader color="#ff6600" size={60} />
        </div>
      )}

      <div className={styles.heroSection}>
        <img src={carImage} alt="Car" className={styles.heroImage} />
        <div className={styles.overlayBox}>
          <span className={styles.brand}>KARZONE</span>
          <h2 className={styles.title}>Next-gen fleet. Instant drive.</h2>
          <p className={styles.subtitle}>
            Rent Your Dream Car. Transparent pricing. Book in seconds.
          </p>
          {/* تعديل الزرار */}
          <button className={styles.ctaButton} onClick={goToCarsPage}>
            See fleet
          </button>
        </div>
      </div>

      <div className={styles.luxuryHeader}>
        <div className={styles.premiumBadge}>
          <FiZap className={styles.iconFlash} />
          <span>Premium Fleet Selection</span>
        </div>
        <h1 className={styles.mainTitle}>Luxury Car Collection</h1>
        <p className={styles.description}>
          Discover premium vehicles with exceptional performance and comfort for your next
          <br />
          journey
        </p>
      </div>

      <div className={styles.dataContainer}>
        <div className={styles.carsGrid}>
          {cars.map((car) => (
            <div key={car.id} className={styles.carCard}>
              <div className={styles.carImage}>
                <img
                  src={car.image || "/placeholder.svg"}
                  alt={car.name}
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = "/luxury-car-dark-theme.png"
                  }}
                />
                <div className={styles.priceTag}>₹{car.price}/day</div>
              </div>

              <div className={styles.carInfo}>
                <h3 className={styles.carName}>{car.name}</h3>
                <div className={styles.carCategory}>Compact Sedan</div>

                <div className={styles.carFeatures}>
                  <div className={styles.feature}>
                    <div className={styles.iconCircle}>
                      <FaUserFriends className={styles.icon} />
                    </div>
                    <span className={styles.featureValue}>{car.seats}</span>
                    <span className={styles.featureLabel}>Seats</span>
                  </div>
                  <div className={styles.feature}>
                    <div className={styles.iconCircle}>
                      <FaGasPump className={styles.icon} />
                    </div>
                    <span className={styles.featureValue}>{car.fuelType}</span>
                    <span className={styles.featureLabel}>Fuel</span>
                  </div>
                  <div className={styles.feature}>
                    <div className={styles.iconCircle}>
                      <FaTachometerAlt className={styles.icon} />
                    </div>
                    <span className={styles.featureValue}>30 MPG</span>
                    <span className={styles.featureLabel}>Average</span>
                  </div>
                  <div className={styles.feature}>
                    <div className={styles.iconCircle}>
                      <BsFillGearFill className={styles.icon} />
                    </div>
                    <span className={styles.featureValue}>{car.transmission}</span>
                    <span className={styles.featureLabel}>Trans</span>
                  </div>
                </div>

                <button className={styles.bookBtn} onClick={() => handleCarSelect(car)}>
                  Book Now →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <section className={styles.testimonialsSection}>
        <div className={styles.testimonialsContainer}>
          {/* Header */}
          <div className={styles.testimonialsHeader}>
            <div className={styles.customerBadge}>
              <FaCar className={styles.badgeIcon} />
              Customer Experiences
            </div>
            <h2 className={styles.testimonialsTitle}>Premium Drive Experiences</h2>
            <div className={styles.titleDivider}>
              <div className={styles.dividerLine}></div>
              <GiSteeringWheel className={styles.steeringIcon} />
              <div className={styles.dividerLine}></div>
            </div>
            <p className={styles.testimonialsSubtitle}>
              Hear from our valued customers about their journey with our premium fleet
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className={styles.testimonialsGrid}>
            {testimonialsData.map((testimonial) => (
              <div key={testimonial.id} className={styles.testimonialCard}>
                {/* Quote and Rating */}
                <div className={styles.cardHeader}>
                  <div className={styles.quoteIcon}>"</div>
                  <div className={styles.rating}>
                    {[...Array(testimonial.rating)].map((_, index) => (
                      <FaStar key={index} className={styles.star} />
                    ))}
                  </div>
                </div>

                {/* Testimonial Text */}
                <p className={styles.testimonialText}>"{testimonial.text}"</p>

                {/* Car Model Badge */}
                <div className={styles.carModelBadge}>
                  <FaCar className={styles.carIcon} />
                  {testimonial.carModel}
                </div>

                {/* Customer Info */}
                <div className={styles.customerInfo}>
                  <div className={styles.customerAvatar}>
                    {testimonial.avatar}
                  </div>
                  <div className={styles.customerDetails}>
                    <div className={styles.customerName}>{testimonial.customerName}</div>
                    <div className={styles.customerRole}>{testimonial.customerRole}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
